import { useCallback, useEffect } from 'react';
import { useIsSmartFieldsNew } from '@atlassian/jira-issue-create-form-context/src/index.tsx';
import { useSmartFieldsUpdateUserPreference } from '@atlassian/jira-personal-settings-gic-smart-fields/src/services/index.tsx';
import { useIsSmartFieldsOptIn } from '@atlassian/jira-router-resources-gic-smart-fields/src/services/index.tsx';

export const useSyncNewLozenge = () => {
	const {
		isSmartFieldsOptIn,
		isSmartFieldDismissedReadMore,
		dismissReadMore,
		isSmartFieldsGicOnboardingDismissed,
	} = useIsSmartFieldsOptIn();

	const { updatePreferences } = useSmartFieldsUpdateUserPreference();

	const dismissLozenge = useCallback(async () => {
		dismissReadMore();
		await updatePreferences({
			hasUserOptedOut: !isSmartFieldsOptIn,
			hasUserDismissedReadMore: true,
			hasUserDismissedGicOnboarding: !!isSmartFieldsGicOnboardingDismissed,
		});
	}, [dismissReadMore, isSmartFieldsOptIn, updatePreferences, isSmartFieldsGicOnboardingDismissed]);

	const [isSmartFieldsNew, { setIsSmartFieldsNew }] = useIsSmartFieldsNew();

	useEffect(() => {
		if (isSmartFieldsNew === undefined && !isSmartFieldDismissedReadMore) {
			setIsSmartFieldsNew(true);
			dismissLozenge();
		}
	}, [isSmartFieldsNew, isSmartFieldDismissedReadMore, setIsSmartFieldsNew, dismissLozenge]);

	return {
		isSmartFieldsNew,
	};
};
